import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { GradeDistributionData } from '../HomePage';

interface Props {
    data: GradeDistributionData[];
}

function BieuDoPhanPhoiDiem({ data }: Props) {
    return (
        <PieChart
            series={[
                {
                    data: data.map((item, index) => ({
                        id: index,
                        value: item.count,
                        label: item.grade
                    }))
                }
            ]}
            width={400}
            height={300}
        />
    );
}

export default BieuDoPhanPhoiDiem;
